import React from "react";

export const Badge: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className = "",
}) => (
  <span
    className={`inline-flex items-center rounded-full border border-[var(--site-border)] bg-[var(--site-surface-elevated)] px-2.5 py-0.5 text-xs font-semibold text-[var(--site-muted)] ${className}`}
  >
    {children}
  </span>
);
